import { UriHelper } from './UriHelper.cs';

// abstract for we do not implement it but helper functions
export abstract class Uri {
  static readonly UriSchemeHttp = 'http';
  static readonly UriSchemeHttps = 'https';
  static readonly SchemeDelimiter = '://';

  static CheckSchemeName(schemeName: string) {
    if (!schemeName || !UriHelper.IsAsciiLetter(schemeName[0])) {
      return false;
    }
    for (let i = schemeName.length; i > 0; --i) {
      if (!(UriHelper.IsAsciiLetterOrDigit(schemeName[i])
        || (schemeName[i] === '+')
        || (schemeName[i] === '-')
        || (schemeName[i] === '.'))) {
        return false;
      }
    }
    return true;
  }
}
